<template>
	<v-navigation-drawer
		width="500px"
		v-model="showDrawer"
		temporary
		app
		right
		floating
		:hide-overlay="false"
		mobile-breakpoint="800"
		:permanent="paymentProcessing"
	>
		<iframe
			height="100%"
			width="100%"
			seamless
			style="border: 0;"
			:src="checkoutUrl"
			@load="setupMessageListener"
			ref="checkoutIframe"
		/>
	</v-navigation-drawer>
</template>

<script>
export default {
	name: "CheckoutDrawer",
	data() {
		return {
			showDrawer: false,
			paymentProcessing: false
		};
	},
	computed: {
		checkoutUrl() {
			return this.$store.state.checkoutUrl;
		}
	},
	methods: {
		// Iframe message listener
		setupMessageListener() {
			try {
				window.addEventListener("message", this.handleMessage);
			} catch (error) {
				// Nothing to do here
			}
		},
		// Handle iframe message
		handleMessage(event) {
			if (this.checkoutUrl) {
				const url = new URL(this.checkoutUrl);
				const hostname = url?.hostname;
				if (!event.origin.includes(hostname)) {
					return;
				}
			}

			const data = event.data;
			switch (data) {
				case "PAYMENT_PROCESSING":
					this.paymentProcessing = true;
					break;
				case "PAYMENT_PROCESSED":
					this.paymentProcessing = false;
					break;
				default:
				// Nothing to do here
			}
		}
	},
	watch: {
		checkoutUrl(newValue) {
			if (newValue !== null) {
				this.showDrawer = true;
			} else {
				this.showDrawer = false;
			}
		}
	},
	beforeDestroy() {
		try {
			window.removeEventListener("message", this.handleMessage);
		} catch (error) {
			// Nothing to do here
		}
	}
};
</script>
